import { request } from "graphql-request";

export default (url, document, variables) => {
    const token = localStorage.getItem('AUTH_TOKEN');
    const headers = { Authorization: token ? `Bearer ${token}` : '' };
    return request(url, document, variables, headers);
};